import { theme } from '../../../themes/main';
import { SxStyles } from '../../../types';

export const styles: SxStyles = {
  buttonGroupField: {
    '.MuiButtonGroup-grouped[aria-checked="true"]': {
      backgroundColor: theme.palette.green.main,
      borderColor: theme.palette.green.main,
    },
  },
};
